import { PODCASTERS_SERVICE, Request } from '../Request';
import { stringify as qsStringify } from 'query-string';

export type PlaylistAdd = {
  homeCardId: string;
  episodeId: string;
  episodeName: string;
  episodeCoverArtUrl: string;
  podcastId: string;
  podcastName: string;
  playlistId: string;
  playlistName: string;
  timeAdded: number;
};
export type FeaturedPlaylistHomeCard = {
  imageUrl: string;
  playlistAdds: PlaylistAdd[];
};
export type ChartAdd = {
  chartColor: string;
  chartCountry: string;
  chartCoverArtUrl: string;
  chartLink: string;
  chartName: string;
  chartRank: number;
  chartUri: string;
  homeCardId: string;
  podcastCoverArtUrl: string;
  podcastId: string;
  podcastName: string;
  timeAdded: string;
};
export type FeaturedChartHomeCard = {
  imageUrl: string;
  chartAdds: ChartAdd[];
};
type HomeCardsResponse = {
  playlistAdds: FeaturedPlaylistHomeCard;
  chartAdds: FeaturedChartHomeCard;
};

export async function getHomeCards(networkId: string | null): Promise<HomeCardsResponse> {
  const response = await Request.of().get(
    `${PODCASTERS_SERVICE}/v0/home/cards?${qsStringify({ networkId }, { skipNull: true })}`,
  );
  return response.json();
}
